<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 12:26:48
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-11-29 10:02:30
-->
<template>
  <div class="comment-wrapper">
    <div class="bottom" :class="source==='list' ? '' : 'van-hairline--top'">
      <div
        @click="handleShare"
        class="operate-item">
        <img style="width: 16px;height: 15px" src="../../../assets/share.png"/>
        <span v-if="rowData.sharedNum">{{rowData.sharedNum}}</span>
      </div>
      <div
        @click="() => handleChat()"
        class="operate-item">
        <!-- <van-icon name="chat-o" size="20" /> -->
        <img style="width: 16px;height: 14px" src="../../../assets/huifu.png"/>
        <span v-if="totalReplyNum || rowData.totalReplyNum">{{totalReplyNum || rowData.totalReplyNum}}</span>
      </div>
      <div
        @click="handleUp" 
        class="operate-item" :class="rowData.isUp > 0 ? 'up' : 'unUp'" >
        <van-icon name="good-job-o" size="20"/>
        <span v-if="rowData.upNum">{{rowData.upNum}}</span>
      </div>
    </div>
    <van-popup
      v-model="showPop"
      position="bottom"
      :safe-area-inset-bottom="true"
      :style="{ height: 'auto', overflow: 'hidden' }">
      <div v-if="showName">
        <div @click="handleChangeName(-1)" class="name-item van-hairline--bottom">
          <div class="avatar-item">
            <van-image
              round
              width="0.5rem"
              height="0.5rem"
              :src="userInfo.avatar"
              />
              <span style="margin-left:10px;">{{userInfo.erpName}}</span>
          </div>
          <van-icon v-if="selectNameIndex === -1" name="success" color="#2695F1" />
        </div>
        <div v-for="(item, index) in 4" :key="index" @click="handleChangeName(index)" class="name-item van-hairline--bottom">
          <div class="avatar-item">
            <van-image
              round
              width="0.5rem"
              height="0.5rem"
              :src="avatarList[index]"
              />
            <span style="margin-left:10px;">{{nameList[index]}}</span>
          </div>
          <van-icon v-if="selectNameIndex === index" name="success" color="#2695F1" />
        </div>
      </div>
      <div v-if="rowData.type && !rowData.tp" @click="handleShowName" style="padding:10px 10px 0 10px;">
        <div class="avatar-item">
          <van-image
            round
            width="0.5rem"
            height="0.5rem"
            :src="selectNameIndex > -1 ? avatarList[selectNameIndex] : userInfo.avatar"
            />
          <span style="margin-left:10px;">{{selectNameIndex > -1 ? nameList[selectNameIndex] : userInfo.erpName}}</span>
          <van-icon name="play" class="play-icon" />
        </div>
      </div>
      <div class="comment-editor">
        <div v-if="fileList.length" class="img-list">
          <van-image
            v-for="(item, index) in fileList"
            :key="index"
            width="40" 
            height="40"
            :src="item.url"
            class="img-item"
          >
            <div @click="handleDeleteImg(index)" class="img-delete">
              <van-icon
                name="cross"
                size="6"
                color="#fff"
                class="img-icon" />
            </div>
          </van-image>
          <!-- <van-divider /> -->
        </div>
        <Editor
          ref="editor"
          class="editor"
          v-model="message"
          @onFocus="handleFocus"
          @onChange="handleEditorChange"
          @customPaste="handleCustomPaste"
          :defaultConfig="editorConfig"
        />
        <div class="comment-btn">
          <van-button
            type="info"
            size="large"
            :disabled="btnDis && !fileList.length"
            @click="handleComment"
            :loading="btnLoading">发 布</van-button>
        </div>
        <van-uploader
          :before-read="beforeRead"
          class="comment-pic">
          <van-icon
            size="0.8rem"
            color="#909399"
            name="photo-o" />
        </van-uploader>
      </div>
    </van-popup>
    <SelectOther
      v-if="showMention"
      @select="handleSelectErp"
      @cancle="hideModal" />
  </div>
</template>

<script>
import { ImagePreview, Toast } from 'vant'
import api from '../../../api'
import { Editor } from '@wangeditor/editor-for-vue'
import { Boot } from '@wangeditor/editor'
import SelectOther from './selectOther.vue'
import mentionModule from '@wangeditor/plugin-mention';
import formulaModule from '@wangeditor/plugin-formula';
import { mapState } from 'vuex'

Boot.registerModule(mentionModule)
Boot.registerModule(formulaModule)


export default {
  props: {
    rowData: {
      type: Object,
      default: () => {}
    },
    source: {
      default: 'list'
    },
    totalReplyNum: {
      type: Number,
      default: 0
    },
    shareLinkKey: {
      type: String,
      default: ''
    },
    onlyReal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Editor,
    SelectOther
  },
  data() {
    return {
      showPop: false,
      showMention: false,
      message: '',
      btnLoading: false,
      detailCom: false,
      detailParams: {},
      scrollTop: '',
      editorConfig: {
        autoFocus: false,
        placeholder: '快来发表评论吧，还可以 @其他人哟',
        EXTEND_CONF: {
          mentionConfig: {
            showModal: this.showModal, // 必须
            hideModal: this.hideModal, // 必须
          },
        },
      },
      avatarIndex: 0,
      // 一开始设置为实名
      selectNameIndex: -1,
      showName: false,
      btnDis: true,
      fileList: [],
    }
  },
  computed: {
    ...mapState(['userInfo', 'nameList', 'avatarList'])
  },
  watch: {
    onlyReal: {
      immediate: true,
      handler(_onlyReal) {
        if (_onlyReal) {
          this.handleChangeName(-1)
        }
      }
    }
  },
  methods: {
    showModal() {
      this.showMention = true
    },
    hideModal() {
      this.showMention = false
    },
    handleShowName() {
      if (!this.showName && this.onlyReal) {
        Toast('该畅聊所属圈子设置了仅允许实名发布和评论')
        return;
      }
      this.showName = !this.showName
    },
    handleSelectErp(item) {
      this.insertNode(item)
      this.showMention = false
    },
    handleChangeName(val) {
      this.selectNameIndex = val
      this.showName = false
    },
    handleChangeAvatar() {
      const index = Math.floor(Math.random() * 20)
      this.avatarIndex = index
    },
    insertNode(item) {
      const mentionNode = {
        type: 'mention',
        value: item.realName,
        info: item.userName,
        children: [{ text: '' }],
      }
      const editor = this.$refs.editor.editor
      if (editor) {
          editor.restoreSelection() // 恢复选区
          editor.deleteBackward('character') // 删除 '@'
          editor.insertNode(mentionNode) // 插入 mention
          editor.move(1) // 移动光标
      }
    },
    handleEditorChange(editor) {
      const text = editor.getText().trim()
      this.btnDis = text.length ? false : true
    },
    handlePreview(url) {
      ImagePreview([url])
    },
    handleLinkDetail() {
      this.$router.push({ name: 'articleDetail', params: { id: this.rowData.id } })
    },
    handleUp() {
      const params = { id: this.rowData.id }
      // this.$set(thi)
      api.upArticle(params).then(res => {
        const { code } = res
        if (code === 200) {
          if (this.source === 'list') {
            this.updatePostView()
          }
          this.$emit('refresh', { ...this.rowData })
          // this.$emit('refresh', { ...data, ...params })
        }
      })
    },

    handleChat(detailCom = false, params) {
      if (this.source === 'list') {
        let name = this.rowData.type === 1 ? 'bbsDetail' : 'articleDetail'
        this.$router.push({ name, params: { id: this.rowData.id }, query: { position: 'chat' } })
        // setTimeout(() => {
        //   document.body.scrollTop = document.documentElement.scrollTop = document.body.clientHeight
        // }, 1200)
        return
      }
      this.showPop = true;
      this.detailCom = detailCom
      if (detailCom) {
        this.detailParams = params
      }
      // if (this.source !== 'list') {
        // document.body.scrollTop = document.documentElement.scrollTop = document.body.clientHeight
      // }
    },
    beforeRead(file) {
      const fd = new FormData();
      fd.append('file', file)
      api.uploadImage(fd).then(res => {
        const { code, data: { url } } = res
        if (code === 200) {
          this.fileList.push({ url })
        }
      })
    },
    handleComment() {
      this.$nextTick(() => {
        const users = this.message.match(/22(\w+)%/gi)
        const atUsers = []
        if (users && users.length) {
          users.forEach(item => {
            atUsers.push(item.slice(2, -1))
          })
        }

        this.btnLoading = true
        let params = {}
        if (!this.detailCom) {
          params = {
            type: this.rowData.type,
            postId: this.rowData.id,
            content: this.message
          }
        } else {
          params = {
            ...this.detailParams,
            content: this.message,
            type: this.rowData.type
          }
        }
        if (this.fileList.length) {
          let imgs = ''
          this.fileList.forEach(item => {
            imgs += `<img src="${item.url}" data-href="" style="width:120px;height:240px;" />`
          })
          params.content += `<br>${imgs}`
        }
        params.atUsers = atUsers
        if (this.rowData.type && this.selectNameIndex > -1) {
          params.anonymousAvatar = this.avatarList[this.selectNameIndex]
          params.anonymousName = this.nameList[this.selectNameIndex]
          api.postReplyAnonymous(params).then(res => {
            this.btnLoading = false
            const { code } = res
            if (code === 200) {
              this.message = ''
              this.$refs.editor.editor.clear()
              this.showPop = false
              this.fileList = []
              Toast.success('评论成功')
              this.$emit('refresh', null, this.detailCom ? this.scrollTop : 'init')
            }
          })
          return;
        }
        
        api.postReply(params).then(res => {
          this.btnLoading = false
          const { code } = res
          if (code === 200) {
            this.message = ''
            this.$refs.editor.editor.clear()
            this.showPop = false
            this.fileList = []
            Toast.success('评论成功')
            this.$emit('refresh', null, this.detailCom ? this.scrollTop : 'init')
          }
        })
      })
    },
    updatePostView() {
      const params = { postId: +this.rowData.id }
      api.newPostView(params)
    },
    handleShare() {
      const { title, info, id, contentText, type } = this.rowData
      const msg = info || contentText;
      const shareId = this.$route.query.shareId ? this.$route.query.shareId : this.userInfo.id;
      let _type = 'article';
      let _title = title;
      switch (type) {
        case 1:
          _type = 'bbs';
          _title = '神灯畅聊'
          break;
        case 4:
          _type = 'codeShow';
          _title = '代码文化-CodeShow'
          break;
      }
      const shareLinkKey = this.shareLinkKey ? `&shareLinkKey=${this.shareLinkKey}` : ''
      const url = `http://sd.jd.com/${_type}/${id}?shareId=${shareId}&isHideShareButton=1${shareLinkKey}`
      const options = {
        shareData: {
          title: _title,
          content: msg,
          url,
          icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
        },
        typeList: ['JDMESession', 'CopyLink'],
        callback: ({status, shareType}) => {
          console.log(status, shareType)
          if (+status === 0) {
            if (this.source === 'list') {
              this.updatePostView();
            }
            if (shareType === 'JDMESession') {
              this.shareSuccess();
            }
          }
          
        }
      }
      window.jme.share.shareCustom(options);
      
    },
    shareSuccess() {
      api.shareSuccess({
        postId: this.rowData.id,
        sharedId: this.userInfo.id
      }).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.$emit('refresh', { id: this.rowData.id, sharedNum: data.sharedNum}, 'share')
        }
      })
    },
    handleFocus() {
      this.scrollTop = document.documentElement.scrollTop;
    },
    handleBlur() {
      document.body.scrollTop = this.scrollTop
    },
    formatHtmlStr(str) {
      if (typeof str === 'string') {
        return str.replace(/<[^<>]+>/g, '')
      }
      return ''
    },
    handleCustomPaste(_editor, event, callback) {
      try {
        let html = event.clipboardData.getData('text/html'); // 获取粘贴的 html
        let text = event.clipboardData.getData('text/plain');

        if (html) {
          event.preventDefault();
          _editor.insertText(text);
          callback(false);
        } else {
          callback(true);
        }
      } catch (err) {
        callback(true);
      }
    },
    handleDeleteImg(index) {
      this.fileList.splice(index, 1)
    }
  }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.comment-wrapper {
  width: 100%;
  display: flex;
  text-align: left;
  margin-top: 6px;
  .comment-editor {
    overflow: hidden;
    position: relative;
  }
  .comment-btn {
    text-align: center;
    width: 100%;
  }
  .comment-pic {
    position: absolute;
    right: 10px;
    bottom: 55px;
  }
  .editor {
    font-size: 14px;
    height: 140px; 
    overflow-y: hidden;
  }
  .name-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 30px 10px 10px;
    font-size: 12px;
  }
  .avatar-item {
    display: flex;
    align-items: center;
    font-size: 12px;
  }
  .play-icon {
    transform: rotate(-30deg);
    position: relative;
    top: -2px;
  }
  .img-list {
    padding: 10px 10px 0 10px;
    /deep/ .img-delete {
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
      height: 14px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 0 0 0 12px;
  }
  /deep/ .img-icon {
    position: absolute;
    right: 1px;
  }
  }
  .img-item {
    margin-right: 10px; 
    position:relative;
  }
}
.bottom {
  display: flex;
  flex: 1;
  .operate-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #606266;
    > span {
      font-size: 14px;
      margin-left: 5px;
    }
  }
  .up {
    color: #2695F1;
    font-weight: 500;
  }
  .unUp {
    color: #606266;
    font-weight: 400;
  }
}

</style>

